import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {}

  public postLogin(credentials: { email: string; password: string }): Observable<any> {
    return this._httpClient.post('/api/auth/login-patient', credentials);
  }

  public postRegister(patient: any): Observable<any> {
    return this._httpClient.post('/api/auth/register', patient);
  }

  public getToken(email: any): Observable<any> {
    return this._httpClient.post('/api/auth/password', email);
  }

  public changePassword(data: { email: any, token: any, password: any, passwordConfirmation: any}): Observable<any> {
    return this._httpClient.put('/api/auth/password', data);
  }

  public logout(): Observable<any> {
    return this._httpClient.delete('/api/auth/logout');
  }

  public getLoggedUser(): Observable<any> {
    return this._httpClient.get('/api/auth/logged-user');
  }

  public createReservation(reservation: { from: Date, till: Date, typeId: any, userId: any }): Observable<any> {
    return this._httpClient.post('/api/reservation', reservation);
  }

  public deleteReservation(reservation :any): Observable<any> {
    return this._httpClient.delete('/api/reservation/'+reservation);
  }

  public getReservationType(): Observable<any> {
    return this._httpClient.get('/api/reservation-type');
  }

  public getReservationGroup(): Observable<any> {
    return this._httpClient.get('/api/reservation-group');
  }

  public getUserReservations(user :any): Observable<any> {
    return this._httpClient.get('/api/user/'+user+'/patient');
  }

  public getFreeTermsSummary(type: string, from: Date, till: Date): Observable<any> {
    return this._httpClient.get('/api/reservation/free-terms/' + type + '/summary', {params: {from: from.toISOString(), till: till.toISOString()}});
  }

  public getFreeTerms(type: string, from: Date, till: Date): Observable<any> {

    return this._httpClient.get('/api/reservation/free-terms/' + type, {params: {from: from.toISOString(), till: till.toISOString()}});
  }

  public getOpenings(type: string, from: Date, till: Date): Observable<any> {

    return this._httpClient.get('/api/reservation/free-terms/'+type+'/no-events', {params: {from: from.toISOString(), till: till.toISOString()}});
  }

}
